import React from 'react'

export default ({ id, title, message, label, onClick }) => (
  <div className="modal fade" id={id} tabIndex="-1" role="dialog">
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{title}</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-link" data-dismiss="modal">Volver</button>
          <button type="button" className="btn btn-primary" onClick={onClick}>{label}</button>
        </div>
      </div>
    </div>
  </div>
)